/*
 * Copyright (c) 2022. Haodong JU
 */

import { IKDataEntity } from 'metaflow-js'
import hillo from 'hillo'
import { baseUrl } from '@/model/storage/index'

const entity = {
  id: {
    type: IKDataEntity.Types.Integer,
    form: false,
    header: false,
  },
  name: {
    displayName: 'resourceName',
  },
  // image: {},
  defaultBarcode: {},
  lowestUnitPrice: {
    type: IKDataEntity.Types.Float,
    formConfig: {
    },
  },
  unitDisplay: {
    displayName: 'currentCount',
    formConfig: {
      default: 0,
    },
    form: false,
  },
  delete: {
    type: IKDataEntity.Types.Integer,
    form: false,
    tableConfig: {
      overwrite: true,
    },
  },
}

const root = 'dishResource'

const config = {
  add: function (item) {
    return hillo.jsonPost(baseUrl + root + '/create', item, {
      showLoading: true,
    })
  },
  edit: function (item) {
    return hillo.jsonPost(baseUrl + root + '/edit/' + item.id, item, {
      showLoading: true,
    })
  },
  remove: function (id) {
    return hillo.post(baseUrl + root + '/delete/' + id,
      { id: id },
    )
  },
  load: async function () {
    const arr = (await hillo.jsonPost(baseUrl + root + '/getList', {}))
      .data
    return arr.map(it => {
      return {
        ...it.dishResource,
        ...it,
      }
    })
  },
}

export default IKDataEntity.ModelFactory(entity, config)
